export function panelClassName(extra = ''): string {
  return `panel matte-frame ${extra}`.trim();
}
